import React from 'react';
import { UserQuestion } from '../../types/UserQuestion';

interface UserQuestionTableProps {
  questions: UserQuestion[];
  loading: boolean;
  onEdit: (question: UserQuestion) => void;
  onDelete: (id: number) => void;
}

const UserQuestionTable: React.FC<UserQuestionTableProps> = ({
  questions,
  loading,
  onEdit,
  onDelete
}) => {
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading User Questions...</p>
      </div>
    );
  }

  if (questions.length === 0) {
    return (
      <div className="empty-state">
        <p>No user questions found. Create your first question by clicking the "Add New Question" button.</p>
      </div>
    );
  }

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Question Text</th>
            <th>User Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {questions.map((question) => (
            <tr key={question.id}>
              <td>{question.id}</td>
              <td>{question.questionText}</td>
              <td>{question.userEmail}</td>
              <td>
                <div className="action-buttons">
                  <button
                    className="edit-button"
                    onClick={() => onEdit(question)}
                    title="Edit Question"
                  >
                    ✏️
                  </button>
                  <button
                    className="delete-button"
                    onClick={() => onDelete(question.id as number)}
                    title="Delete Question"
                  >
                    🗑️
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserQuestionTable; 